export const UI_LOCALES = ['en', 'pl', 'he'] as const;

export type UiLocale = (typeof UI_LOCALES)[number];

export const UI_LOCALE_STORAGE_KEY = 'fintitles_locale';

export function isUiLocale(value: string | null | undefined): value is UiLocale {
  return value === 'en' || value === 'pl' || value === 'he';
}

export function getDocumentDirection(locale: string): 'rtl' | 'ltr' {
  return locale === 'he' ? 'rtl' : 'ltr';
}

export function readStoredLocale(): UiLocale {
  try {
    const stored: string | null = window.localStorage.getItem(UI_LOCALE_STORAGE_KEY);
    return isUiLocale(stored) ? stored : 'en';
  } catch {
    return 'en';
  }
}

export function storeLocale(locale: UiLocale): void {
  try {
    window.localStorage.setItem(UI_LOCALE_STORAGE_KEY, locale);
  } catch {
    // Storage can be unavailable in private browsing or restricted environments.
  }
}

export function applyDocumentLocale(locale: string): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = locale;
  document.documentElement.dir = getDocumentDirection(locale);
}
